import { render, staticRenderFns } from "./reService.vue?vue&type=template&id=6b83bc6d&scoped=true&"
import script from "./reService.vue?vue&type=script&lang=js&"
export * from "./reService.vue?vue&type=script&lang=js&"
import style0 from "./reService.vue?vue&type=style&index=0&id=6b83bc6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83bc6d",
  null
  
)

export default component.exports